<template>
  <div class="search-links">
    <hr />
    <ul>
      <b-collapse :open="false" aria-id="adultLearning">
        <button
          class="button is-link"
          slot="trigger"
          aria-controls="adultLearning"
          v-on:click="linkAL = !linkAL"
        >
          <b-icon v-bind:class="{ active: linkAL }" icon="menu-right"></b-icon>
          <a href="http://www.getty.edu/education/adult_learners/index.html"
            >Adult Learners</a
          >
        </button>
        <ul>
          <li>
            <a
              href="http://www.getty.edu/education/adult_learners/getty_artists_program/index.html"
              >Getty Artist Program</a
            >
          </li>
          <li>
            <a
              href="http://www.getty.edu/education/adult_learners/sketching_gallery.html"
              >Sketching Gallery</a
            >
          </li>
          <li>
            <a
              href="http://www.getty.edu/education/adult_learners/timescape_room.html"
              >Timescape Room</a
            >
          </li>
        </ul>
      </b-collapse>
      <b-collapse :open="false" aria-id="collegeFacultyStudents">
        <button
          class="button is-link"
          slot="trigger"
          aria-controls="collegeFacultyStudents"
          v-on:click="linkCFS = !linkCFS"
        >
          <b-icon v-bind:class="{ active: linkCFS }" icon="menu-right"></b-icon>
          <a href="http://www.getty.edu/education/college/index.html"
            >College Faculty and Students</a
          >
        </button>
        <ul>
          <li>
            <a
              href="http://www.getty.edu/education/college/villa_collegenight_2010.html"
              >College Night at Getty Villa</a
            >
          </li>
          <li>
            <a
              href="http://www.getty.edu/education/college/olwe_masterclass.html"
              >Engaged Student Observers</a
            >
          </li>
          <li>
            <a href="http://www.getty.edu/education/college/berman_project.html"
              >Where We Live: Student Perspectives</a
            >
          </li>
        </ul>
      </b-collapse>
      <b-collapse
        :open="true"
        aria-id="k12TeachersStudents"
        class="active-links"
      >
        <button
          class="button is-link"
          slot="trigger"
          aria-controls="k12TeachersStudents"
          v-on:click="linkK12 = !linkK12"
        >
          <b-icon v-bind:class="{ active: linkK12 }" icon="menu-right"></b-icon>
          <a href="http://www.getty.edu/education/teachers/index.html"
            >K-12 Teachers and Students</a
          >
        </button>
        <ul class="is-nested">
          <b-collapse :open="false" aria-id="planningSchoolVisit">
            <button
              class="button is-link"
              slot="trigger"
              aria-controls="planningSchoolVisit"
              v-on:click="linkPSV = !linkPSV"
            >
              <b-icon
                v-bind:class="{ active: linkPSV }"
                icon="menu-right"
              ></b-icon>
              <a
                href="http://www.getty.edu/education/teachers/trippack/index.html"
                >Planning a School Visit</a
              >
            </button>
            <ul class="is-nested">
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/trippack/activities.html"
                  >Visit Activities</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/trippack/center/center_visits.html"
                  >School Visits at the Getty Center</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/trippack/villa/villa_visits.html"
                  >School Visits at the Getty Villa</a
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="false" aria-id="professionalDevelopment">
            <button
              class="button is-link"
              slot="trigger"
              aria-controls="professionalDevelopment"
              v-on:click="linkPD = !linkPD"
            >
              <b-icon
                v-bind:class="{ active: linkPD }"
                icon="menu-right"
              ></b-icon>
              <a
                href="http://www.getty.edu/education/teachers/professional_dev/index.html"
                >Professional Development</a
              >
            </button>
            <ul class="is-nested">
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/professional_dev/ala/index.html"
                  >Art &amp; Language Arts</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/professional_dev/sti/index.html"
                  >Secondary Teachers' Institute</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/professional_dev/center_orientation/index.html"
                  >Teacher Orientation Workshop &ndash; Getty Center</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/professional_dev/villa_orientation/index.html"
                  >Teacher Orientation Workshop &ndash; Getty Villa</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/professional_dev/tow/index.html"
                  >Teachers' Open Workshops</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/professional_dev/vsi/index.html"
                  >Villa Summer Institute</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/professional_dev/wtw/index.html"
                  >Wednesday Teacher Workshops</a
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="true" aria-id="resourcesClassroom">
            <button
              class="button is-link"
              slot="trigger"
              aria-controls="resourcesClassroom"
              v-on:click="linkR = !linkR"
            >
              <b-icon
                v-bind:class="{ active: linkR }"
                icon="menu-right"
              ></b-icon>
              <a
                href="http://www.getty.edu/education/teachers/classroom_resources/index.html"
                >Resources for the classroom</a
              >
            </button>
            <ul class="is-nested">
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/classroom_resources/curricula/index.html"
                  >All Curricula</a
                >
              </li>
              <li>
                <a class="active" href="/search/museumed"
                  >Search Lessons &amp; Activities</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/teachers/classroom_resources/tips_tools/index.html"
                  >Tips and Tools for Teaching</a
                >
              </li>
            </ul>
          </b-collapse>
          <li>
            <a
              href="http://www.getty.edu/education/teachers/student_resources/index.html"
              >Resources for Students</a
            >
          </li>
          <li>
            <a
              href="http://www.getty.edu/education/teacherartexchange/index.html"
              >TeacherArtExchange</a
            >
          </li>
        </ul>
      </b-collapse>
      <b-collapse :open="false" aria-id="kidsFamily">
        <button
          class="button is-link"
          slot="trigger"
          aria-controls="kidsFamily"
          v-on:click="linkKF = !linkKF"
        >
          <b-icon v-bind:class="{ active: linkKF }" icon="menu-right"></b-icon>
          <a href="http://www.getty.edu/education/kids_families/index.html"
            >Kids and Family</a
          >
        </button>
        <ul>
          <b-collapse :open="false" aria-id="prepareYourVisit">
            <button
              class="button is-link"
              slot="trigger"
              aria-controls="prepareyourVisit"
              v-on:click="linkPYV = !linkPYV"
            >
              <b-icon
                v-bind:class="{ active: linkPYV }"
                icon="menu-right"
              ></b-icon>
              <a
                href="http://www.getty.edu/education/kids_families/before/index.html"
                >Preparing for your visit</a
              >
            </button>
            <ul>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/exploring_art/index.html"
                  >Exploring Art at the Getty Center</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/exploring_antiquity/index.html"
                  >Exploring Art of the Ancient World at the Getty Villa</a
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="false" aria-id="familyEventsActivities">
            <button
              class="button is-link"
              slot="trigger"
              aria-controls="familyEventsActivities"
              v-on:click="linkFEA = !linkFEA"
            >
              <b-icon
                v-bind:class="{ active: linkFEA }"
                icon="menu-right"
              ></b-icon>
              <a
                href="http://www.getty.edu/education/kids_families/programs/index.html"
                >Family Events and Activities</a
              >
            </button>
            <ul>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/art_odyssey.html"
                  >Art Odyssey/Odisea de Arte</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/art_quest.html"
                  >ArtQuest!</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/art_lab.html"
                  >Family Art Lab</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/art_stops.html"
                  >Family Art Stops</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/family_drawing_hour.html"
                  >Family Drawing Hour</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/family_workshops.html"
                  >Family Workshops</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/garden_concerts.html"
                  >Garden Concerts for Kids</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/center_family_festival.html"
                  >Getty Center Family Festivals</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/villa_family_festival.html"
                  >Getty Villa Family Festivals</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/family_forum.html"
                  >The Family Forum</a
                >
              </li>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/programs/family_room.html"
                  >The Family Room</a
                >
              </li>
            </ul>
          </b-collapse>
          <b-collapse :open="false" aria-id="toDoHome">
            <button
              class="button is-link"
              slot="trigger"
              aria-controls="toDoHome"
              v-on:click="linkTDH = !linkTDH"
            >
              <b-icon
                v-bind:class="{ active: linkTDH }"
                icon="menu-right"
              ></b-icon>
              <a
                href="http://www.getty.edu/education/kids_families/do_at_home/index.html"
                >To Do at Home</a
              >
            </button>
            <ul>
              <li>
                <a
                  href="http://www.getty.edu/education/kids_families/do_at_home/artscoops/index.html"
                  >Art Scoops</a
                >
              </li>
            </ul>
          </b-collapse>
        </ul>
      </b-collapse>
      <li>
        <a href="http://www.getty.edu/education/groups/index.html"
          >Community Groups</a
        >
      </li>
      <li>
        <a href="http://www.getty.edu/education/museum_educators/index.html"
          >Museum Educators</a
        >
      </li>
      <li>
        <a href="http://www.getty.edu/education/about/index.html"
          >About the Education Department</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SearchMusEdLinks",
  data() {
    return {
      linkAL: false,
      linkCFS: false,
      linkK12: true,
      linkPSV: false,
      linkPD: false,
      linkR: true,
      linkKF: false,
      linkPYV: false,
      linkFEA: false,
      linkTDH: false
    };
  }
};
</script>

<style lang="scss" scoped>
span,
button {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
button {
  a {
    color: black;
    &:hover {
      text-decoration: underline;
    }
  }
}
a,
span {
  font-size: $size-7;
}
a {
  display: inline-flex;
}
.button.is-link {
  height: 1em;
  &:focus:not(:active) {
    box-shadow: none;
  }
}
.active-links {
  border-top: 1px dotted #666666;
  border-bottom: 1px dotted #666666;
  margin: 0 0 0 -1.5em !important;
  padding-left: 0.5em !important;
  background-color: #f3f3f3;
}
.is-nested {
  background: transparent !important;
}
li {
  line-height: 1;
}
</style>
